import type {FetchProfileResponse} from '../../http';
import {fetchProfile} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

export function useFetchProfile(options?: UseQueryOptions<FetchProfileResponse>) {
	return useQuery<FetchProfileResponse>({
		queryKey: ['profile'],
		queryFn: async ({signal}) => {
			const {data} = await fetchProfile(signal);

			return data;
		},
		...options,
	});
}
